import React, {
	Component
} from 'react';
import Global from '../../../Global';

import './PhoneBundles.css';
import ArrowLeftWhite from '../../../svgs/arrow-left-white.svg';
import ArrowRightWhite from '../../../svgs/arrow-right-white.svg';
import ArrowLeftBlack from '../../../svgs/arrow-left-black.svg';
import ArrowRightBlack from '../../../svgs/arrow-right-black.svg';
import BackArrowWhite from '../../../svgs/back-arrow-white.svg';
import BackArrowBlack from '../../../svgs/back-arrow.svg';



class PhoneBundles extends Component {

	constructor(props) {
		super(props);

		this.state = {
			pages: [],
			columnHeight: 0,
			pageChanging: null,
			phoneSelecting: null,
			currentPage: 0,
			showCapacityPhoneId: null,
			currentPhoneId: null,
			currentCapacityIndex: null,
			currentPlanIndex: null,
			currentPhoneOffsetClass: null,
			currentPlanOffsetClass: null,
			planSelected: false,
			data: {
				general: null,
				phones: null
			}
		}
	}

	resetPages() {
		if (this.refs.phones && this.refs.container) {
			const allHeight = this.refs.phones.offsetHeight;
			const columnHeight = this.refs.container.offsetHeight;
			const pageCount = parseInt(allHeight / columnHeight, 10);
			const pages = [];
			let i = 0;
			for (; i < pageCount; i++) {
				pages.push(i);
			}
			this.setState({
				pages,
				columnHeight,
				currentPage: 0
			})
		}
	}

	goToPage(currentPage) {
		if (0 <= currentPage && currentPage < this.state.pages.length) {
			this.setState({
				pageChanging: true
			}, _ => {
				this.pageChangingTimer = setTimeout(_ => {

					this.setState({
						currentPage,
						pageChanging: false
					})
				}, 200)
			})
		}
	}

	componentDidMount() {

        var url = Global.getAPI(this.props.apiCallPath);
        fetch(url)
			.then(function(response) {
				if (response.status >= 400) {
					throw new Error('Error API: ' + this.props.apiCallPath);
				}
				return response.json();
			})
			.then(data => this.setState({
				data
			}, this.resetPages));

		window.addEventListener('resize', this.resetPages.bind(this))
	}

	back() {
		if(this.state.planSelected){
			this.setState({
				planSelected: false
			})
		}
		if (this.state.currentPlanIndex != undefined) {
			this.setState({
				currentPlanIndex: null
			})
		} else if (this.state.currentPhoneId) {
			this.setState({
				currentPhoneId: null
			})
		}
	}

	showCapacity(phoneId, e) {
		phoneId && phoneId.stopPropagation && phoneId.stopPropagation();
		e && e.stopPropagation && e.stopPropagation();
		if (!this.state.currentPhoneId && !this.state.showCapacityPhoneId && typeof phoneId === 'string') {
			const phone = this.state.data.phones[phoneId];
			if (phone && phone.capacity.length > 1) {
				this.setState({
					showCapacityPhoneId: phoneId
				})
			} else {
				this.selectPhone(phoneId, 0);
			}
		} else {
			this.setState({
				showCapacityPhoneId: null
			})
		}
	}


	selectPhone(phoneId, capacityIndex, e) {
		e && e.stopPropagation && e.stopPropagation();
		const phones = Object.keys(this.state.data.phones);
		const offsetIndex = phones.indexOf(phoneId) % 5;
		if (offsetIndex > -1) {
			this.setState({
				currentPhoneId: phoneId,
				currentCapacityIndex: capacityIndex,
				phoneSelecting: true,
				currentPhoneOffsetClass: 'offset_' + offsetIndex
			}, _ => {
				setTimeout(_ => {
					this.setState({
						currentPhoneOffsetClass: 'offset_0'
					}, _ => {
						this.phoneSelectingTimer = setTimeout(_ => {
							this.setState({
								phoneSelecting: false
							});
						}, 400);
					});
				}, 400);
			})
		}
	}
	selectPlan(planIndex) {
		let offsetIndex = planIndex;

		if(planIndex >=4){
			offsetIndex = 0;
		}

		if (offsetIndex > -1) {
			// console.log(offsetIndex);
			// console.log(planIndex);
			this.setState({
				currentPlanIndex: planIndex,
				planSelecting: true,
				currentPlanOffsetClass: 'offset_' + offsetIndex,
				planSelected: true
			}, _ => {
				setTimeout(_ => {
					this.setState({
						currentPlanOffsetClass: 'offset_0'
					}, _ => {
						this.planSelectingTimer = setTimeout(_ => {
							this.setState({
								planSelecting: false
							});
						}, 400);
					});
				}, 400);
				this.refs.planCTA.focus();
			})
		}
	}

	render() {

			const currentPhoneData = this.state.data.phones && this.state.data.phones[this.state.currentPhoneId];
			const currentCapacityData = currentPhoneData && currentPhoneData.capacity[this.state.currentCapacityIndex];
			const currentPlanData = currentCapacityData && currentCapacityData.plans[this.state.currentPlanIndex];

			

			const $phone = (phoneId, onClick, className, style) => {
				const phone = this.state.data.phones[phoneId];
				return phone ? <li
				key = {
					phoneId
				}
				onClick = {
					onClick
				}
				className = {
					'phone' + (className ? ' ' + className + ' ' : '') +
					((this.state.showCapacityPhoneId === phoneId || this.state.currentPhoneId === phoneId) ?
						' showCapacity ' :
						this.state.showCapacityPhoneId && this.state.showCapacityPhoneId !== phoneId ? ' fadeout ' : '')
				}
				style = {
						style
					} >
					<div className="phone-container">
						<img className='img phone-img' loading='lazy' src={encodeURI(phone.image)}/>
						<div>
							<div className="selected-capacity">{(this.state.currentPhoneId === phoneId && this.state.currentCapacityIndex != undefined) ? phone.capacity[this.state.currentCapacityIndex].label : ''}</div>
							<div className='title'>{phone.label}</div>
						</div>
						<div className="capacity-select" onClick={this.showCapacity.bind(this)}>
							<div className='capacity-list'>
									{phone.capacity.map((capacity, capacityIndex) => (
										<div className="capacity" key={capacityIndex} onClick={this.selectPhone.bind(this, phoneId, capacityIndex)}>
											<div className='label'>{capacity.label}</div>
										</div>
									)
								)}
							</div>
						</div> 

			            {/* <div className='img' style={{backgroundImage:'url(' + encodeURI(phone.image) + ')'}}></div> */}
			            {/* <div className="selected-capacity">{(this.state.currentPhoneId === phoneId && this.state.currentCapacityIndex != undefined) ? phone.capacity[this.state.currentCapacityIndex].label : ''}</div>
			            <div className='title'>{phone.label}</div>
			            <div className="capacity-select" onClick={this.showCapacity.bind(this)}>
			            	<div className='capacity-list'>
					            {phone.capacity.map((capacity, capacityIndex) => <span
					            	key={capacityIndex} 
					            	onClick={this.selectPhone.bind(this, phoneId, capacityIndex)}
					            	className='capacity'>{capacity.label}
				            	</span>)}
			            	</div>
			            </div> */}
	    			</div> </li> :
				null
			}

			const $plan = (planIndex, onClick, className, style) => {
				const plan = currentCapacityData.plans[planIndex]
				return plan ? <li 
				key={planIndex}
				onClick={onClick}
				className={'plan-container' + (className ? ' ' + className + ' ' : '')} 
    			style={style}>
    			<div className="price-container">
					<h3>
						{plan.dataAmount}
						<span className='priceNote'>{plan.plusNote}</span>
					</h3>
					<div className="line"></div>
					<div className="price-data">
						<div className="center-price">
	    					<h4>
	    						$
	    						<span className="price">{plan.price}</span>
								<span className='plusNote'>{plan.priceNote}</span>
	    					</h4>
						</div>
					</div>
    			</div>
				<div className="bonus">
					<h5>{plan.portInBonus}</h5>
					<p className='extra'>{plan.extra}</p>
				</div>
			</li> :
					null
			}

			return (this.state.data.general && this.state.data.phones) ?
				<div className={'phone-bundles container clearfix' + (this.props.theme ? ' ' + this.props.theme + ' ' : '')} onClick={this.showCapacity.bind(this)}>
				<div className='headline'>
					<div className='blurb'>
						<h4 className="title">{this.state.data.general.title}</h4>
						<h1 className='title-text'>{this.state.data.general.description}</h1>
					</div>
				</div>
				<div className={'phones' + (this.state.currentPhoneId ? ' in-bundle ' : '')}>

	                <div className={'step-headline' + (this.state.currentPhoneId ? ' shift ' : '')}>
	                	<div className="headline-container">
		                	<h5 className="header-label1">{this.state.currentPlanIndex != undefined ? 
		                			'' :
		                			this.state.currentPhoneId ? this.state.data.step2.desc : this.state.data.step1.desc}</h5>
		                	<span className="header-label2" onClick={this.back.bind(this)}>
			                	{this.state.currentPlanIndex != undefined ?
			                		this.state.data.general.bundleSummary :
			                		this.state.currentPhoneId ? this.state.data.step2.headline : this.state.data.step1.headline}
			                </span>
		                	<img alt='back'  onClick={this.back.bind(this)} src={this.props.theme === 'white' ? BackArrowBlack : BackArrowWhite} 
								className={'back-arrow'+ (this.state.currentPhoneId ? '' : ' hiding ')}			
							/>
	                	</div>
	                </div>
	                <a className={'view-more' + (this.state.currentPhoneId ? ' hiding ' : '')} href={this.state.data.step1.viewMoreUrl}>{this.state.data.step1.viewMoreLabel}</a>

                	<img alt='previous' className={'arrow left' + (this.state.currentPage > 0  ? '' : ' disabled ') + (this.state.currentPhoneId ? ' hiding ' : '') } 
            			onClick={
						this.goToPage.bind(this, this.state.currentPage - 1)
						}
            			src={this.props.theme === 'white' ? ArrowLeftBlack : ArrowLeftWhite} />

                	<img alt='next' className={'arrow right' + (this.state.currentPage < (this.state.pages.length - 1) ? '' : ' disabled ') + (this.state.currentPhoneId ? ' hiding ' : '')} 
                	onClick={this.goToPage.bind(this, this.state.currentPage + 1)} 
                		src={this.props.theme === 'white' ? ArrowRightBlack : ArrowRightWhite} />

                	{
                		!currentCapacityData ?
	                	<span className='pages'>
	                		{this.state.pages.map((page, index) => {
	                			return <span key={index} onClick={this.goToPage.bind(this, page)} className={'point' + (page === this.state.currentPage ? ' active ':'')}></span>
	                		})}
	                	</span>
	                	:
	                	null
                	}
	                <div ref='container' className={"phone-compare-phones" + (currentCapacityData && currentCapacityData.plans.length > 4 && !this.state.planSelected ? " secondLine ": '' )}>
	                	<div className="phone-compare-container">
		                    <ul ref='phones' className={'phone-list' + (this.state.pageChanging ? ' changing ' : '') + (this.state.currentPhoneId ? ' hiding ' : '')} style={{marginTop: -this.state.columnHeight * this.state.currentPage + 'px'}}>
		                        {Object.keys(this.state.data.phones).map( (phoneId) => {
							        	return [ $phone(phoneId, this.showCapacity.bind(this, phoneId)), ' '];
							        }
						        )}
		                        {[0,1,2,3,4].map((value,index) =>{
		                            return [<li key={'_p_' + index} className='placeholder' style={{visibility:'hidden'}}></li>,' ']
		                        })}
		                    </ul>
	                        {currentCapacityData ? 
	                        	<div className={"bundle-select" + (this.state.currentPlanIndex != undefined ? ' layout ' : '')}>
	                        		{$phone(this.state.currentPhoneId, null, 
	                        				'in-bundle' + 
	                        				(this.state.phoneSelecting ? ' movement ' : '') + 
	                        				(this.state.currentPhoneOffsetClass ? ' ' + this.state.currentPhoneOffsetClass + ' ' : ''))}
	                        		<div className="phone-placeholder"></div>

	                        		{
	                        			currentCapacityData.plans.map((plan, index) => {
	                        				return [(index%4) == 0 && index != 0? <div className="phone-placeholder"></div>:null, ' ', $plan(index, this.selectPlan.bind(this, index), this.state.phoneSelecting || this.state.planSelecting || this.state.currentPlanIndex != undefined ? ' hiding ' : '')];
	                        			})
									}



			                        {[0,1,2,3,4].map((value,index) => {
			                            return [' ', <li key={'_p_' + index} className='placeholder' style={{visibility:'hidden'}}></li>]
									})}
	                        	</div>
	                        	:
	                        	null
	                        }
							{currentPlanData ? 
	                        	<div className="plan-select">
	                        		{$plan(this.state.currentPlanIndex, null, 
	                        				'in-plan' + 
	                        				(this.state.planSelecting ? ' movement ' : '') + 
	                        				(this.state.currentPlanOffsetClass ? ' ' + this.state.currentPlanOffsetClass + ' ' : ''))}
	                        		<div className={"plan-detail" + (this.state.planSelecting ? ' hiding ' : '')}>
		                        		<div className="price-box">
		                        			<div className="sub-price">
		                        				<h6>{this.state.data.general.handsetPrice}</h6>
		                        				<div className="price">$<span className='amount'>{currentPlanData.handsetPrice}</span></div>
		                        			</div>
		                        			<div className="pre-pay">
		                        				<h6>{this.state.data.general.prepayment}</h6>
		                        				<div className="price">$<span className='amount'>{currentPlanData.prepayment}</span></div>
		                        			</div>
		                        			<p className='note'>{currentPlanData.prepaymentNote}</p>
		                        		</div>
	                        			<div className="action">
	                        				<a href={currentPlanData.ctaUrl} className="cta" ref='planCTA'>{this.state.data.general.planDetails}</a>
	                        			</div>
	                        		</div>
	                        	</div>
	                        	:
	                        	null
							}
	                	</div>
	                </div>
				</div>

		</div> : null;
	}
}


export default PhoneBundles;